export const WORKFLOWS = [
  {
    id: "listing-agreement",
    short: "L",
    title: "New Listing Agreement",
    mobileTitle: "Listing Agreement",
    description: "Submit a signed listing to operations.",
    side: "Seller"
  },
  {
    id: "buyer-agreement",
    short: "B",
    title: "New Buyer Agreement",
    mobileTitle: "Buyer Agreement",
    description: "Submit a signed buyer agreement to operations.",
    side: "Buyer"
  },
  {
    id: "under-contract",
    short: "UC",
    title: "Mark Under Contract",
    mobileTitle: "Under Contract",
    description: "Convert an existing buyer or listing.",
    side: ""
  },
  {
    id: "pending-without-record",
    short: "P",
    title: "Pending Without Prior Record",
    mobileTitle: "New Pending",
    description: "Fallback only when no earlier record exists.",
    side: ""
  }
];

export const EMPTY_SUMMARY = {
  activeListings: 0,
  pendingtransactions: 0,
  awaitingReview: 0,
  mySubmissions: 0,
  overdueTasks: 0,
  projectedRevenue: 0
};
